import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as IconPartnerSvg }  from '../../assets/icons/icon_partner_blue.svg';

const PartnerIcon=(props)=>{
    return <Icon component={() => <IconPartnerSvg />} {...props}/>
}

export default PartnerIcon;